<template>
  <div class="mainSection">
    <div class="container">
      <Interface
        v-if="this.localStorage.email"
        :buttons="buttons"
        :key="this.localStorage.email.last_update"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Interface from 'components/setting/interface/Interface'
export default {
  name: 'settingInterfaceDesktop',
  components: { Interface },
  data() {
    return {}
  },
  created() {
    if (
      !this.localStorage.email ||
      this.localStorage.email.language_id !== $cookies.get('languageSelect').id
    ) {
      this.onTranslationsAllPage({
        language_id: $cookies.get('languageSelect').id,
        storage: this.localStorage,
        type: 'email',
      })
    } else {
      this.onTranslationsLastUpdate({
        language_id: $cookies.get('languageSelect').id,
        type: 'email',
      }).then((resp) => {
        if (resp !== this.localStorage.email.last_update) {
          this.onTranslationsAllPage({
            language_id: $cookies.get('languageSelect').id,
            storage: this.localStorage,
            type: 'email',
          })
        }
      })
    }
  },
  methods: {
    ...mapActions('translations', ['onTranslationsAllPage', 'onTranslationsLastUpdate']),
  },
  computed: {
    buttons() {
      return [
        {
          text: this.localStorage.email.pages.mail_invite.titles['priglashenie-v-proapp'],
          icon: 'interface-employee-invite',
          link: 'settingInterfaceMail_invite',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.titles,
              icon: 'interface-common-titles',
              link: 'settingInterfaceMob_invite_titles',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.texts,
              icon: 'interface-common-text',
              link: 'settingInterfaceMob_invite_text',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.buttons,
              icon: 'interface-common-buttons',
              link: 'settingInterfaceMob_invite_buttons',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.footer,
              icon: 'interface-footer',
              link: 'settingInterfaceMob_invite_footer',
            },
          ],
        },
        {
          text: this.localStorage.email.pages.mail_password.titles[
            'vosstanovleniya-parolya-v-proapp'
          ],
          icon: 'interface-restore',
          link: 'settingInterfaceMail_password',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.titles,
              icon: 'interface-common-titles',
              link: 'settingInterfaceMob_password_titles',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.texts,
              icon: 'interface-common-text',
              link: 'settingInterfaceMob_password_text',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.buttons,
              icon: 'interface-common-buttons',
              link: 'settingInterfaceMob_password_buttons',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.footer,
              icon: 'interface-footer',
              link: 'settingInterfaceMob_password_footer',
            },
          ],
        },
        {
          text: this.localStorage.email.pages.mail_offer.titles['main'],
          icon: 'interface-restore',
          link: 'settingInterfaceMail_price-offer',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.titles,
              icon: 'interface-common-titles',
              link: 'settingInterfaceMail_price-offer_titles',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.buttons,
              icon: 'interface-common-buttons',
              link: 'settingInterfaceMail_price-offer_buttons',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.footer,
              icon: 'interface-footer',
              link: 'settingInterfaceMail_price-offer_footer',
            },
          ],
        },
        {
          text: this.localStorage.email.pages.report_signe.fields['for_signature'],
          icon: 'interface-common-edit',
          link: 'settingInterfaceMail-report_sign',
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped></style>
